<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left">
        <img src="../assets/img/返回箭头.png" class="nav-img" @click="back()" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">礼物墙</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <li class="menu-block" v-for="(item, index) in ary" :key="index">
      <div class="item ub ub-ac2">
        <div class="avatar">
          <img :src="item.photo_to" alt="">
        </div>
        <div class="from-info ub ub-ver ub-ac1 ub-f1">
          <span >{{ item.nick_to }}<label> 收到了</label></span>
          <span >{{ item.dtm }}</span>
        </div>
        <div class="gift ub">
          <img :src="item.gift_item.url" alt="">
          <div class="ub ub-ver ub-ac3 num">
            <span>{{ item.gift_item.name }} × 1</span>
            <span>魅力<label>+{{ item.gift_item.score }}</label></span>
          </div>
        </div>
        </div>
        <div class="menu-line"></div>
      </li>

    <div class="ub ub-pc ub-ac"  v-if="ary.length > 0">
      <div class="ub ub-ac ub-pc btn" @click="load_more()"><span>加载更多</span></div>
    </div>

    <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="notData">
        <img src="../assets/img/new2024/no-gift.png" alt="">
        <span class="tip-404">暂无礼物</span>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import * as tool from "../api/common";
export default {
  data() {
    return {
      uid: "",
      ary: [],
      index: 0,
      size: 20,
      notData: false,
      theme_dark: false
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },

  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      //接收参数
      if (this.$route.params.uid) {
        this.uid = this.$route.params.uid;
      }

      var gift_wall = this.$store.state.http_cache.gift_wall;
      
      if (gift_wall.dtm != "") {
        if (gift_wall.data_serve.length == "") {
          this.notData = true;
        }
        var dtm = gift_wall.dtm;
        var dtm_now = new Date().getTime();

        var tsp = dtm_now - dtm;
        var ss = Math.floor(tsp / 1000);
        if (ss < 60) {
          this.ary = gift_wall.data_serve;
          return false;
        }
      }
      this.load_more();
    },

    load_more() {

      var const_data = this.$store.state.const_data;
      var ary_gift = const_data.gift_1.concat(const_data.gift_2);

      //计算index
      var index = parseInt(this.ary.length / this.size);
      if (index > this.index || (index == 0 && this.ary.length == 0)) {
        this.index = index;
      } else {
        this.$toast.center("没有更多了~");
        return false;
      }

      
      //加载数据(按条数加载)
      var self = this;
      this.$loading("正在加载中...");
      self.get({
        url: "/App/GetGiftDtl/?uid=" + this.uid + "&index=" + this.index + "&size=" + this.size,
        success: function (data) {
          self.$loading.close();

          if (data.length == "") {
            self.notData = true;
          }
          var gift_item;
            for (var i = 0; i < data.length; i++) {
              data[i].photo_from = self.$store.state.url + "/photo/" + data[i].photo_from;
              data[i].photo_to = self.$store.state.url + "/photo/" + data[i].photo_to;
              gift_item = tool.getGiftItemBy_name(ary_gift, data[i].comment);
              data[i].gift_item = gift_item;
            }
            self.ary = self.ary.concat(data);

            var obj = {
                dtm: new Date().getTime(),
                data_serve: self.ary
            }
            self.$store.commit("set_http_cache", {gift_wall: obj});
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #FDFDFD;
  .btn {
    margin: 1rem 0;
    padding: 0.5rem 8rem;
    border-radius: 2rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

  .no-404 {
    margin-top: 10rem;
    background-size: 100% 100%;
    .tip-404 {
      margin-top: 1rem;
      font-size: 0.75rem;
    }
  }
}

.menu-block {
  padding: 0 0.8rem;
  .item {
    padding: 1rem 0;
  }
  .avatar {
    img {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
    }
  }
  .from-info {
    margin-left: 1rem;
    padding: 0.3rem 0;
    label {
      margin-left: 0.2rem;
      font-size: 0.9rem;
      color: #666;
      font-weight: 100;
    }
  }
  .from-info span:nth-child(1) {
    font-size: 0.9rem;
    font-weight: bold;
    color: #333;
  }
  .from-info span:nth-child(2) {
    font-size: 0.75rem;
    color: #333;
  }
  .gift {
    padding: 0.1rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    .num {
      margin-left: 0.5rem;
      span {
        font-size: 0.75rem;
        color: #333;
      }
      label {
        color: #BA61FF;
      }
    }
  }
  .menu-line {
    border-top: 1px solid #EFEFEF;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .menu-block {
    .item {
      .from-info {
        span {
          color: #FDFDFD;
          label {
            color: #888;
          }
        }
      }
      .gift {
        .num {
          span {
            color: #FDFDFD;
          }
        }
      }
    }
  }
  .menu-line {
      border-top: 1px solid #404040;
  }
  .no-404 {
    .tip-404 {
      color: #dfdfdf;
    }
  }
}
</style>
